import { render, staticRenderFns } from "./ResourceManagement.vue?vue&type=template&id=a1d7fc7e&scoped=true&"
import script from "./ResourceManagement.vue?vue&type=script&lang=ts&"
export * from "./ResourceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceManagement.vue?vue&type=style&index=0&id=a1d7fc7e&lang=scss&scoped=true&"
import style1 from "./ResourceManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d7fc7e",
  null
  
)

export default component.exports